var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStamp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.26 2a3 3 0 0 1 2.992 3.23L14.654 13H19a2 2 0 0 1 2 2v2a2 2 0 0 1-1.017 1.742Q20 18.868 20 19v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1q0-.132.017-.259A2 2 0 0 1 3 17v-2a2 2 0 0 1 2-2h4.346l-.598-7.77A3 3 0 0 1 11.74 2zM18 19H6v1h12zm1-4H5v2h14zM12.26 4h-.52a1 1 0 0 0-.997 1.077L11.352 13h1.298l.61-7.962V5a1 1 0 0 0-1-1"
})));
export default SvgStamp;